import classes from '../notificationSettings.scss';
import { getLocalizedStrings } from '../../profileSettingsLocalizedStrings';
import TextBox from "../Presentational/SceEmailText";
import DeleteEmail from './deleteEmail';

const EmailPreferences = (props) => {
  const removeIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Action_Remove.svg';
  const infoIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Information.svg';
  const warningIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg';
  let strings = getLocalizedStrings('NotificationSettings');
  let emailToolTipStyle= props.data.showEmailToolTip ? classes.emailInfoToolTip : null;
  
  return(
  
    <div>
      {props.data.emailIds.map((obj,index)=>{
        return (
          (index <= 2) ?
            <div>
              {((props.editButton) && (obj.email === props.editEmail)) ?
                <div>
                  <div className={classes.box}>
                    <span lassName={classes.textBox}>
                    <TextBox type='cenPrefEmail' maxLength={45} validator={app.appUtil.validator} emailCallback={props.emailCallback}  emailValue={(props.newMail!=="") ? props.newMail : obj.email} />
                   
                    
                      <div>{props.data.emailPrefErr ? <div className={classes.warningBox}>  <span className={classes.warningImg}><img src={warningIcon} alt="Warning Icon" /></span> <span className={classes.warnMsg}>{strings.lessThanMsg1} {props.data.preferenceError.join(', ')}{". "}{strings.lessThanMsg2}</span></div>:''}</div>
                     

                      <span className={classes.saveCancelButtonAlign}>
                      <button className={classes.SaveButtonEmail} onClick={()=>{props.saveButtonHandler();}} disabled={props.disabledSave}>{strings.SaveButtonValue}</button>

                        <button className={classes.CancelButtonEmail} onClick={props.cancelButtonHandler}>{strings.CancelButtonValue}</button>

                      </span>
                      </span>
                    
                    
                    {props.emailExistErrMsg ? <span className={classes.errMsg}>{props.emailExistErrMsg}</span> : null}
                    
                    {props.modifyError ? <span className={classes.errMsg}>{strings.errorMsg}</span> : null}
                  </div>



                </div> : (props.data.removeButtonPress && obj.email === props.data.removeEmail) ? <DeleteEmail email={obj.sequenceNumber} data={props.data} removeButtonHandler={props.removeButtonHandler} removeCancelHandler={props.removeCancelHandler} />
                  :
                  <div>
                      {app.appService.getUserInfo().email.toLowerCase() === obj.email.toLowerCase() ?
                      <div className={classes.loginEmail}>
                        {((props.newMail!=="") && (obj.email===props.editEmail)) ? <span className={classes.edititem}> {props.newMail.replace(/^(...)(.*)(@.*)$/, (_, a, b, c) => a + '****' + c)}</span> : <span className={classes.edititem}> {obj.email.replace(/^(...)(.*)(@.*)$/, (_, a, b, c) => a + '****' + c)}</span> }
                        <div className={classes.infoIcon}><button tabIndex={-1} className={classes.sceImageButton} aria-label="Info icon"><img tabIndex={0} onKeyPress={props.toolTipKeyPress} src={infoIcon} alt="Info Icon" /></button> <div className={classes.infoToolTip+' '+ emailToolTipStyle}>{"You can't modify Login Email"}</div></div>
                        </div> 
                        :
                       <div>
                          <div className={classes.row1}>
                        {/* checking whether delete icon is needede if you have more than 10 contract accounta */}
                        <div><button className={classes.sceImageButton} id={obj.email} onClick={(event) => props.removeHandler(event,obj.email)}> <img src={removeIcon} alt='Remove  Icon' /> </button></div>
                         
                          {((props.newMail!=="") && (obj.email===props.editEmail)) ? <span className={classes.edititem}> {props.newMail.replace(/^(...)(.*)(@.*)$/, (_, a, b, c) => a + '****' + c)}</span> : <span className={classes.edititem}> {obj.email.replace(/^(...)(.*)(@.*)$/, (_, a, b, c) => a + '****' + c)}</span> }
                          <div className={classes.editButtonPadding}><button className={classes.editButton} id={obj +" "+ strings.emailEdit+""+index} onClick={(event, email) => props.editHandler(event, obj.email,obj.sequenceNumber)}>{strings.editBtn}</button></div>
      
                        </div>
                {(!(obj.twoFAVerified.toLowerCase() === "true"))?   <div className={classes.verifyLink} > <a className={classes.aVerifyLink} href="JavaScript:void(0)" onClick={()=>props.verifyHandler(obj.email,'Email','V',"",obj.sequenceNumber)}> {strings.verifyEmail} </a> </div> : null }
                        
                         </div>
                        }
                      </div>
                }

              <div className={classes.dividerLine} />
            </div> : '');
      })}

    </div>
  );
};
export default EmailPreferences;
